module.exports = __webpack_public_path__ + "static/media/cctv.0470dd75.svg";